import { ForeignSystem } from 'common/types/Entities';

import { _request,APIBaseResponse, APIMethod } from '..';

const FOREIGN_SYSTEMS_PREFIX = '/foreignsystems';

export type APIForeignSystemsGetResponse = APIBaseResponse<ForeignSystem[]>;

export const APIForeignSystemsGet: APIMethod<void, APIForeignSystemsGetResponse> = () => (
    _request('GET', FOREIGN_SYSTEMS_PREFIX)
);
